import { create } from "apisauce";
import { API_URI } from "../utils/contants";
import { getDomain } from "../utils";

const apiClient = create({
  baseURL: `${API_URI}`,
  headers: {
    DOMAIN: getDomain(),
  },
  timeout: 60000,
});


export default apiClient;
